import { Coupon } from '@definitions/types/symfonyTypes'

/**
 * Creates the full URL for a coupon's frontend image
 * Handles both production (with NEXT_PUBLIC_SYMFONY_URL) and Storybook (relative paths)
 */
export function createCouponImageUrl(coupon: Coupon): string {
  const path = coupon.frontendImage?.publicPath
  if (!path) {
    return ''
  }
  
  const baseUrl = process.env.NEXT_PUBLIC_SYMFONY_URL
  
  // If baseUrl is undefined (e.g., in Storybook), use relative path
  if (!baseUrl) {
    // Ensure path starts with / for absolute paths
    return path.startsWith('/') ? path : `/${path}`
  }
  
  // Remove leading slash from path if baseUrl already ends with /
  const cleanPath = path.startsWith('/') ? path.slice(1) : path
  const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl
  
  return `${cleanBaseUrl}/${cleanPath}`
}
